/* eslint-disable import-x/no-namespace */
import { filterIsApplied, FilterMenu } from '@vlabs/monokit/shared/ui/filter-menu';
import { Control } from '@vlabs/uikit';
import { omit } from 'lodash';
import { useTranslation } from 'react-i18next';

import * as sideMenuFilters from './side-menu';
import { useListListPageFilters } from '../useListListPageFilters';

function ListListPageFilterMenu(): JSX.Element {
  const { t } = useTranslation();
  const { filters, resetFilters } = useListListPageFilters();

  const isResetDisabled = Object
    .values(omit(filters, 'page', 'page_size'))
    .filter((value) => value !== undefined)
    .length === 0;

  return (
    <FilterMenu
      filters={[
        <sideMenuFilters.NameFilterWithLeftPopover
          badge={filterIsApplied(!!filters.user_data)}
          key="user_data"
          testId="userDataFilter"
          value={t('list-list-page:filters.popovers.name.label')}
        />,
        <sideMenuFilters.CreationDateFilterWithLeftPopover
          badge={filterIsApplied(!!(filters.create_time__lt ?? filters.create_time__gte))}
          key="create_time"
          testId="createTimeFilter"
          value={t('list-list-page:filters.popovers.creation_date.label')}
        />,
        <sideMenuFilters.UpdateDateFilterWithLeftPopover
          badge={filterIsApplied(!!(filters.last_update_time__lt ?? filters.last_update_time__gte))}
          key="last_update_time"
          testId="lastUpdateTimeFilter"
          value={t('list-list-page:filters.popovers.update_date.label')}
        />,
      ]}
      footer={(
        <Control.Button
          data-testid="button.reset-list-list-filters"
          disabled={isResetDisabled}
          fullWidth
          kind="negative"
          onClick={() => resetFilters()}
          type="button"
        >
          {t('list-list-page:filters.buttons.reset_button.label')}
        </Control.Button>
      )}
    />
  );
}

export { ListListPageFilterMenu };
